let baseUrl = window.location.origin;

const baseUrlEAuthDev = "https://dev.e-authn-api.miestudio.dev.errepar.com";
const baseUrlEAuthQa =
  "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api";

const prodConfig = {
  REACT_APP_REDIRECT_DEFAULT: "https://www.errepar.com",
  REACT_APP_LIST_URLS_REDIRECT_REPLACE: `["/sitios/eolgestion","/sitios/suscriptores"]`,
  REACT_APP_URL_NOTIFY_EAUTH: `${baseUrl}/eauth/eAuth/auth/notifyLoginUserEAuth`,
  REACT_APP_URL_ADMIN_SET_USER_PASSWORD: `${baseUrl}/eauth/eAuth/setPassword`,
  REACT_APP_URL_VERIFY_USER_COGNITO: `${baseUrl}/eauth/auth/getUser/verifyUserCognito`,
  REACT_APP_URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION: `${baseUrl}/eauth/eAuth/subscriptor/getEmailByNumberSubscription`,
  REACT_APP_URL_GET_AUTO_CREDENTIALS: `${baseUrl}/eauth/auth/getAutoCredentialsEAuth`,
  REACT_APP_URL_GET_USER_INVITE: `${baseUrl}/eauth/invite`,
  REACT_APP_URL_VALIDATE_TOKEN: `${baseUrl}/eauth/auth/validateToken`,
  ECHO_ERREPAR: "https://accounts.errepar.com/echo",
  URL_REDIRECT_DEFAULT_ME: "https://miestudio.ar/",
  URL_REDIRECT_DEFAULT_CGI: "https://webcgi.errepar.com/",
  POST_MESSAGE_URL_ME: "TBD",
  URL_GENERATE_JWT3: `${baseUrl}/eauth/eAuth/auth/generateJwt3`,
  ANCESTOR_ORIGIN_ME: "https://miestudio.ar/",
  AUTOLOGIN_EMAIL_USER_EAUTH: `${baseUrl}/eauth/auth/email/autoLoginEmailUserEAuth`,
  AUTOLOGIN_OAT_USER_EAUTH: `${baseUrl}/eauth/auth/email/autoLoginOTAUserEAuth`,
  URL_IFRAME_ALICUOTAS: "https://alicuotas.errepar.com/",
  TERMS_AND_CONDITIONS_URL:
    "https://accounts.errepar.com/syserrepar/business-services/erp/commercialproducts/commercial-use-rules-api",
  URL_RECORD_ACCOUNT_LOGIN_FAIL:
    "https://accounts.errepar.com/sessions/api/esession/recordAccountLoginFailEAuth",
  URL_SESSIONS: "https://accounts.errepar.com/sessions/api/esession",
  URL_GET_JOB_CREDENTIALS: `${baseUrl}/eauth/auth/job/getJobCredentialsEAuth`,
  URL_LOGOUT_ME: "https://ccdn.miestudio.ar/logout/logout.html",
  ANCESTOR_ORIGIN_ME_DECLARATIONS: "https://declarations.uat.miestudio.ar/",
  ANCESTOR_ORIGIN_ME_MIGRATION: "https://migration.uat.miestudio.ar/",
  REACT_GOOGLE_AUTH_CLIENT_ID:
    "566358218438-509iv4b0cmgilainl2gvp1r78npiuqrs.apps.googleusercontent.com",
  REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH:
    `${baseUrl}/eauth/eAuth/auth/generateLoginUserCredentialEAuth`,
  ANCESTOR_ORIGIN_ME_EVENTANILLA: "https://eventanilla.uat.miestudio.ar",
  ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA:
    "https://webappreact-eventanilla.uat.miestudio.ar/",
  LOGIN_ACCOUNT: "https://accounts.errepar.com/login/api",
  REACT_APP_URL_SUBMIT_NEW_USER:
    "https://api.errepar.com/syserrepar/erpmessagebrokerapi/",
  REACT_APP_URL_RESEND_CONFIRMATION_EMAIL:
    "https://accounts.errepar.com/corp-customer-api/api",
};

const uatConfig = {
  REACT_APP_REDIRECT_DEFAULT: "https://www.errepar.com/",
  REACT_APP_LIST_URLS_REDIRECT_REPLACE: `["/sitios/eolgestion","/sitios/suscriptores"]`,
  REACT_APP_URL_NOTIFY_EAUTH: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/auth/notifyLoginUserEAuth`,
  REACT_APP_URL_ADMIN_SET_USER_PASSWORD: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/setPassword`,
  REACT_APP_URL_VERIFY_USER_COGNITO: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/getUser/verifyUserCognito`,
  REACT_APP_URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/subscriptor/getEmailByNumberSubscription`,
  REACT_APP_URL_GET_AUTO_CREDENTIALS: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/getAutoCredentialsEAuth`,
  REACT_APP_URL_GET_USER_INVITE: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/invite`,
  REACT_APP_URL_VALIDATE_TOKEN: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/validateToken`,
  ECHO_ERREPAR: "https://accounts.uat.errepar.com/echo",
  URL_REDIRECT_DEFAULT_ME: "https://uat.miestudio.ar",
  URL_REDIRECT_DEFAULT_CGI: "https://cgi.uat.errepar.com", //Agregar https cuando cgi vuelva a tener certificados válidos
  POST_MESSAGE_URL_ME: "TBD",
  URL_GENERATE_JWT3: `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/auth/generateJwt3`,
  ANCESTOR_ORIGIN_ME: "https://uat.miestudio.ar/",
  AUTOLOGIN_EMAIL_USER_EAUTH: `https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/email/autoLoginEmailUserEAuth`,
  AUTOLOGIN_OAT_USER_EAUTH: `https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/email/autoLoginOTAUserEAuth`,
  URL_IFRAME_ALICUOTAS: "https://uat.alicuotas.errepar.com:8446/MisAlicuotas",
  TERMS_AND_CONDITIONS_URL:
    "https://accounts.uat.errepar.com/syserrepar/business-services/erp/commercialproducts/commercial-use-rules-api",
  URL_RECORD_ACCOUNT_LOGIN_FAIL:
    "https://accounts.uat.errepar.com/sessions/api/esession/recordAccountLoginFailEAuth",
  URL_GET_JOB_CREDENTIALS: `https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/job/getJobCredentialsEAuth`,
  URL_LOGOUT_ME: "https://ccdn.uat.miestudio.ar/logout/logout.html",
  ANCESTOR_ORIGIN_ME_DECLARATIONS: "https://declarations.uat.miestudio.ar/",
  ANCESTOR_ORIGIN_ME_MIGRATION: "https://migration.uat.miestudio.ar/",
  REACT_GOOGLE_AUTH_CLIENT_ID:
    "566358218438-5qjbgtjeehaofmff1m62ffek16hhpfu1.apps.googleusercontent.com",
  REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH:
    `${baseUrl}/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/auth/generateLoginUserCredentialEAuth`,
  ANCESTOR_ORIGIN_ME_EVENTANILLA: "https://eventanilla.uat.miestudio.ar/",
  URL_SESSIONS: "https://accounts.uat.errepar.com/sessions/api/esession",
  ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA:
    "https://webappreact-nuevoperiodofiscal.uat.miestudio.ar/",
  LOGIN_ACCOUNT: "https://accounts.uat.errepar.com/login/api",
  REACT_APP_URL_SUBMIT_NEW_USER:
    "https://api.uat.errepar.com/syserrepar/erpmessagebrokerapi/",
  REACT_APP_URL_RESEND_CONFIRMATION_EMAIL:
    "https://accounts.uat.errepar.com/corp-customer-api/api",
};

const qaConfig = {
  REACT_APP_REDIRECT_DEFAULT: "https://lsds.public.awsalphadeve.com/",
  REACT_APP_LIST_URLS_REDIRECT_REPLACE: `["/sitios/eolgestion","/sitios/suscriptores"]`,
  REACT_APP_URL_NOTIFY_EAUTH: `${baseUrlEAuthQa}/eAuth/auth/notifyLoginUserEAuth`,
  REACT_APP_URL_ADMIN_SET_USER_PASSWORD: `${baseUrlEAuthQa}/eAuth/setPassword`,
  REACT_APP_URL_VERIFY_USER_COGNITO: `${baseUrlEAuthQa}/auth/getUser/verifyUserCognito`,
  REACT_APP_URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION: `${baseUrlEAuthQa}/eAuth/subscriptor/getEmailByNumberSubscription`,
  REACT_APP_URL_GET_AUTO_CREDENTIALS: `${baseUrlEAuthQa}/auth/getAutoCredentialsEAuth`,
  REACT_APP_URL_GET_USER_INVITE: `${baseUrlEAuthQa}/invite`,
  REACT_APP_URL_VALIDATE_TOKEN: `${baseUrlEAuthQa}/auth/validateToken`,
  ECHO_ERREPAR: "https://accounts.qa.errepar.com/echo",
  URL_REDIRECT_DEFAULT_ME: "https://qa.miestudio.ar",
  URL_REDIRECT_DEFAULT_CGI: "https://cgi.qa.errepar.com",
  POST_MESSAGE_URL_ME: "TBD",
  URL_GENERATE_JWT3: `${baseUrlEAuthQa}/eAuth/auth/generateJwt3`,
  ANCESTOR_ORIGIN_ME:
    document.referrer.includes("localhost") ||
    document.referrer.includes("127.0.0.1")
      ? document.referrer
      : "https://qa.miestudio.ar/",
  AUTOLOGIN_EMAIL_USER_EAUTH: "TBD",
  AUTOLOGIN_OAT_USER_EAUTH:
    "http://localhost:3005/auth/email/autoLoginOTAUserEAuth",
  URL_IFRAME_ALICUOTAS: "https://uat.alicuotas.errepar.com:8446/MisAlicuotas",
  TERMS_AND_CONDITIONS_URL:
    "https://accounts.qa.errepar.com/syserrepar/business-services/erp/commercialproducts/commercial-use-rules-api",
  URL_RECORD_ACCOUNT_LOGIN_FAIL:
    "https://accounts.dev.errepar.com/sessions/api/esession/recordAccountLoginFailEAuth",
  URL_GET_JOB_CREDENTIALS: `${baseUrlEAuthQa}/auth/job/getJobCredentialsEAuth`,
  URL_LOGOUT_ME: "https://qa.miestudio.ar/logout",
  ANCESTOR_ORIGIN_ME_DECLARATIONS: "https://declarations.uat.miestudio.ar/",
  ANCESTOR_ORIGIN_ME_MIGRATION: "https://migration.uat.miestudio.ar/",
  ANCESTOR_ORIGIN_ME_EVENTANILLA: "https://eventanilla.dev.miestudio.ar/",
  REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH: `https://api.dev.errepar.com/syserrepar/eauthn-beta/eAuth/auth/generateLoginUserCredentialEAuth`,
  REACT_GOOGLE_AUTH_CLIENT_ID:
    "893411082437-9uebq9h403tcq1ng19n1ooh4g99qcrfn.apps.googleusercontent.com",
  URL_SESSIONS: "https://accounts.uat.errepar.com/sessions/api/esession",
  LOGIN_ACCOUNT: "https://accounts.errepar.com/login/api",
};

const devConfig = {
  REACT_APP_REDIRECT_DEFAULT: "https://lsds.public.awsalphadeve.com/",
  REACT_APP_LIST_URLS_REDIRECT_REPLACE: `["/sitios/eolgestion","/sitios/suscriptores"]`,
  REACT_APP_URL_NOTIFY_EAUTH: `${baseUrlEAuthDev}/eAuth/auth/notifyLoginUserEAuth`,
  REACT_APP_URL_ADMIN_SET_USER_PASSWORD: `${baseUrlEAuthDev}/eAuth/setPassword`,
  REACT_APP_URL_VERIFY_USER_COGNITO: `${baseUrlEAuthDev}/auth/getUser/verifyUserCognito`,
  REACT_APP_URL_GET_EMAIL_BY_NUMBER_SUSBCRIPTION: `${baseUrlEAuthDev}/eAuth/subscriptor/getEmailByNumberSubscription`,
  REACT_APP_URL_GET_AUTO_CREDENTIALS: `${baseUrlEAuthDev}/auth/getAutoCredentialsEAuth`,
  REACT_APP_URL_GET_USER_INVITE: `${baseUrlEAuthDev}/invite`,
  REACT_APP_URL_VALIDATE_TOKEN: `${baseUrlEAuthDev}/auth/validateToken`,
  ECHO_ERREPAR: "https://accounts.dev.errepar.com/echo",
  URL_REDIRECT_DEFAULT_ME: "https://dev.webapp-react.miestudio.dev.errepar.com",
  URL_REDIRECT_DEFAULT_CGI: "https://dev.webcgi.miestudio.dev.errepar.com",
  POST_MESSAGE_URL_ME: "TBD",
  URL_GENERATE_JWT3: `${baseUrlEAuthDev}/eAuth/auth/generateJwt3`,
  ANCESTOR_ORIGIN_ME:
    document.referrer.includes("localhost") ||
    document.referrer.includes("127.0.0.1")
      ? document.referrer
      : "https://dev.webapp-react.miestudio.dev.errepar.com/",
  AUTOLOGIN_EMAIL_USER_EAUTH: `${baseUrlEAuthDev}/auth/email/autoLoginEmailUserEAuth`,
  AUTOLOGIN_OAT_USER_EAUTH: `${baseUrlEAuthDev}/auth/email/autoLoginOTAUserEAuth`,
  URL_IFRAME_ALICUOTAS: "https://uat.alicuotas.errepar.com:8446/MisAlicuotas",
  TERMS_AND_CONDITIONS_URL:
    "https://accounts.dev.errepar.com/commercial-use-rules-api",
  URL_RECORD_ACCOUNT_LOGIN_FAIL:
    "https://accounts.dev.errepar.com/sessions/api/esession/recordAccountLoginFailEAuth",
  URL_GET_JOB_CREDENTIALS: `${baseUrlEAuthDev}/auth/job/getJobCredentialsEAuth`,
  URL_LOGOUT_ME: "https://ccdn.dev.miestudio.ar/logout/logout.html",
  ANCESTOR_ORIGIN_ME_DECLARATIONS:
    "https://declarations.webapp-react.miestudio.dev.errepar.com/",
  ANCESTOR_ORIGIN_ME_MIGRATION: "https://migration.uat.miestudio.ar/",
  ANCESTOR_ORIGIN_ME_EVENTANILLA: "https://eventanilla.dev.miestudio.ar/",
  REACT_APP_URL_GENERATE_LOGIN_USER_CREDENTIAL_EAUTH: `${baseUrlEAuthDev}/eAuth/auth/generateLoginUserCredentialEAuth`, //generateLoginUserCredentialEAuth
  REACT_GOOGLE_AUTH_CLIENT_ID:
    "566358218438-8r9so6qmocrngnf3dr6a281md5ar4tpv.apps.googleusercontent.com",
  URL_SESSIONS: "https://accounts.dev.errepar.com/sessions/api/esession",
  ANCESTOR_ORIGIN_WEBAPP_ME_EVENTANILLA:
    "https://webappreact-eventanilla.dev.miestudio.ar/",
  LOGIN_ACCOUNT:
    "https://dev.suscribers-login-module.miestudio.dev.errepar.com/api",
  REACT_APP_URL_SUBMIT_NEW_USER:
    "https://api.dev.errepar.com/syserrepar/erpmessagebrokerapi/",
  REACT_APP_URL_RESEND_CONFIRMATION_EMAIL:
    "http://dev.corp-customer-api.miestudio.dev.errepar.com/api",
};

export { prodConfig, uatConfig, qaConfig, devConfig };
